import type { FAAKnowledgeTest } from '@/types/Performance';

function formatFAAKnowledgeTestArray(faakt: FAAKnowledgeTest[]): string {
    return faakt.length > 0 ? faakt.map((grade) => `${grade.score}`).join(', ') : '--';
}

export {
    formatFAAKnowledgeTestArray,
};
